// extracted by mini-css-extract-plugin
module.exports = {"payment-profile__agreement":"payment-profile_payment-profile__agreement__3gJp1"};